/**
 * Note:
 * These breakpoints should be kept in sync with the breakpoints specified in
 *  /app/assets/stylesheeets/_settings.global.scss
 *
 * Device mapping:
 *  small -> mobile
 *  medium -> tablet
 *  large -> laptop
 *  xlarge+ -> desktop
 *
 * Examples:
 *  if (breakpoints.upTo_small())     // mobile
 *  if (breakpoints.upFrom_xlarge())  // around desktop and higher
 *  if (breakpoints.upTo_large())     // mobile to tablet
 *  if (breakpoints.within_xxlarge()) // high res only
 */
const doc = typeof document !== 'undefined' && document;
const win = typeof window !== 'undefined' && window;
const docEle = doc && doc.documentElement;
const breakpoints = {
  smallMin: 0,
  smallMax: 568,
  mediumMin: 569,
  mediumMax: 768,
  largeMin: 769,
  largeMax: 1023,
  xlargeMin: 1024,
  xlargeMax: 1365,
  xxlargeMin: 1366,
  xxlargeMax: Number.MAX_VALUE,
  getViewportWidth: () => Math.min(docEle.clientWidth, win.innerWidth),
};
const screenSizes = ['small', 'medium', 'large', 'xlarge', 'xxlarge'];

screenSizes.forEach(size => {
  breakpoints[`within_${size}`] = () => breakpoints[`${size}Min`] <= breakpoints.getViewportWidth() && breakpoints.getViewportWidth() <= breakpoints[`${size}Max`];
  breakpoints[`upTo_${size}`] = () => breakpoints.getViewportWidth() <= breakpoints[`${size}Max`];
  breakpoints[`upFrom_${size}`] = () => breakpoints.getViewportWidth() >= breakpoints[`${size}Min`];
  breakpoints[`largerThan_${size}`] = () => breakpoints.getViewportWidth() > breakpoints[`${size}Max`];
  breakpoints[`smallerThan_${size}`] = () => breakpoints.getViewportWidth() < breakpoints[`${size}Min`];
});

breakpoints.getScreenSize = () => {
  const matchingScreenSizes = screenSizes.filter(size => breakpoints[`within_${size}`]());

  return matchingScreenSizes.length ? matchingScreenSizes[0] : null;
};

window.breakpoints = breakpoints;

export default breakpoints;
